var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":_vm.onClick}},[_c('icon',{attrs:{"icon":_vm.refreshIcon,"spin":_vm.isRefreshing}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }